import { render, staticRenderFns } from "./site2026Auth.vue?vue&type=template&id=2fac0627&"
import script from "./site2026Auth.vue?vue&type=script&lang=js&"
export * from "./site2026Auth.vue?vue&type=script&lang=js&"
import style0 from "./site2026Auth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports